import server from '../services/server';
import {
    applyContractPlaceholders,
    hasContractPlaceholders,
    sanitizeContractHtmlForEditor,
} from './contractTextPlaceholders';

/**
 * Template base do contrato (arquivo no servidor), já sanitizado para o editor.
 */
export async function fetchContractBaseTemplate() {
    const { data: response } = await server.get('subscription/contract-text/default');
    return sanitizeContractHtmlForEditor(response?.data || '');
}

/**
 * Busca a proposta atualizada, processa sempre a partir do template base e salva.
 * Só age se a proposta já tiver texto de contrato (evita gravar sem o usuário ter aberto a seção).
 */
export async function processAndSaveContractText(uuid, { mutate } = {}) {
    if (!uuid) return false;

    const { data: response } = await server.get(`subscription/${uuid}`);
    const contract = response?.data;
    if (!contract?.contractData?.contractText) return false;

    const source = await fetchContractBaseTemplate();
    if (!source || !hasContractPlaceholders(source)) return false;

    const processed = applyContractPlaceholders(source, contract);

    await server.put(`subscription/${uuid}/contract-text`, {
        contractText: processed,
        contractTextSource: source,
    });

    await mutate?.();
    return true;
}
